<template>
    <div class="bloque-general">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="bloque-general__encabezado">
                        <h2>Bolsa de Trabajo</h2>
                    </div>
                </div>
            </div>

            <div class="logo-bolsa">
                <img src="https://bolsadetrabajo.santiago.gob.mx/images/logo.png" alt="Bolsa de Trabajo Santiago Nuevo Leon"/>
            </div>

            <div class="row">
                    <EmpleoBox v-for="(item, index) in empleos" :key="index" :item="item" class="col-12 col-md-3 mb-4" />
            </div>

            <div class="row text-center">
                <div class="col-md-12">
                    <div class="bloque-boton bloque-boton--pb-none">
                        <a href="https://bolsadetrabajo.santiago.gob.mx/" target="_blank" class="boton-principal boton-flecha">Ver más ofertas de empleo</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.logo-bolsa{
    display: flex;
    flex-direction: row;
    justify-content: center;
}
.logo-bolsa img{
    width: 250px;
    margin-bottom: 40px;
}
</style>

<script>
import EmpleoBox from '../../Shared/Empleos/EmpleoBox.vue'
import axios from 'axios'

export default {
    components: { EmpleoBox },
    async mounted() {
        this.getEmpleos()
    },
    data() {
        return {
            empleos: []
        }
    },
    methods: {
        getEmpleos: async function (centros) {
            await axios.get('https://bolsadetrabajo.santiago.gob.mx/api/empleos?limit=8')
                .then((response) => {
                    this.empleos = response.data
                })
                .catch((error) => {
                    console.log(error)
                })
        }
    }
}
</script>
